var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocomotive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 24,
    viewBox: "0 0 90 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.97 17.913H.377c-.208 0-.377.155-.377.346v1.077c0 .191.169.346.377.346H1.97c.208 0 .377-.155.377-.346V18.26c0-.191-.169-.346-.377-.346z",
    fill: "#333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M2.33 18.157a.363.363 0 0 0-.11-.015H.627c-.1 0-.196.036-.266.101a.331.331 0 0 0-.111.244v1.075c0 .034.005.067.015.1a.38.38 0 0 1-.188-.12.328.328 0 0 1-.077-.198v-1.075c0-.045.01-.09.028-.132a.343.343 0 0 1 .081-.112.406.406 0 0 1 .266-.101H1.97c.079 0 .156.021.221.063a.35.35 0 0 1 .14.17z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m3.84 19.06-3.158.169a.304.304 0 0 1-.208-.07.256.256 0 0 1-.065-.084.236.236 0 0 1-.022-.101v-.429c0-.035.007-.07.022-.101a.256.256 0 0 1 .065-.085.302.302 0 0 1 .208-.07l3.157.169v.602z",
    fill: "#4D4D4D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m1.357 18.695-.626-.005v-.256l.626.023v.238zM2.103 18.7l-.511-.004v-.23l.511.018v.217zM2.723 18.705l-.424-.003v-.21l.424.015v.198zM3.247 18.71l-.36-.003v-.194l.36.014v.183zM1.357 19.063l-.626.023v-.258l.626-.005v.24zM2.103 19.034l-.511.02v-.232l.511-.005v.217zM2.723 19.01l-.424.017v-.211l.424-.003v.198zM3.247 18.99l-.36.015v-.194l.36-.003v.183zM.322 19.57h.554v.117a.155.155 0 0 1-.052.114.185.185 0 0 1-.124.048H.503a.185.185 0 0 1-.124-.047.155.155 0 0 1-.052-.114v-.117H.322zM1.22 19.57h.554v.117a.155.155 0 0 1-.051.114.185.185 0 0 1-.125.048h-.2a.185.185 0 0 1-.124-.047.155.155 0 0 1-.052-.114v-.117h-.001zM88.03 19.683h1.591c.209 0 .378-.154.378-.345V18.26c0-.19-.169-.346-.377-.346h-1.593c-.208 0-.377.155-.377.346v1.078c0 .19.169.345.377.345z",
    fill: "#333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M87.67 18.157a.365.365 0 0 1 .109-.015h1.594c.1 0 .196.036.267.101.07.065.11.153.11.244v1.075a.332.332 0 0 1-.015.1.378.378 0 0 0 .191-.125.326.326 0 0 0 .074-.204V18.26a.33.33 0 0 0-.11-.245.396.396 0 0 0-.267-.1H88.03a.4.4 0 0 0-.225.067.347.347 0 0 0-.136.176z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m86.161 19.06 3.157.169a.302.302 0 0 0 .208-.07.256.256 0 0 0 .065-.084.235.235 0 0 0 .023-.101v-.429a.238.238 0 0 0-.023-.101.258.258 0 0 0-.064-.085.305.305 0 0 0-.208-.07l-3.158.169v.602z",
    fill: "#4D4D4D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m88.642 18.695.625-.005v-.256l-.625.023v.238zM87.895 18.7l.512-.004v-.23l-.511.018v.217zM87.277 18.705l.425-.003v-.21l-.425.015v.198zM86.752 18.71l.36-.003v-.194l-.36.014v.183zM88.642 19.063l.625.023v-.258l-.625-.005v.24zM87.895 19.034l.512.02v-.232l-.511-.005v.217zM87.277 19.01l.425.017v-.211l-.425-.003v.198zM86.752 18.99l.36.015v-.194l-.36-.003v.183zM89.5 19.85h-.2a.185.185 0 0 1-.125-.047.155.155 0 0 1-.052-.114v-.116h.554v.116a.155.155 0 0 1-.052.114.185.185 0 0 1-.124.048zM88.6 19.85H88.4a.185.185 0 0 1-.125-.047.155.155 0 0 1-.051-.114v-.116h.553v.116a.155.155 0 0 1-.051.114.185.185 0 0 1-.125.048z",
    fill: "#333"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M84.388 10.17h.67c.184 0 .359.067.488.186.13.118.202.278.202.446v5.886h-1.36V10.17z",
    fill: "#B3B3B3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.758 10.384c0 .152-.05.3-.142.427a.827.827 0 0 1-.376.283.912.912 0 0 1-.485.043.867.867 0 0 1-.43-.21.75.75 0 0 1-.229-.393.707.707 0 0 1 .048-.443.787.787 0 0 1 .309-.345.895.895 0 0 1 .787-.07.848.848 0 0 1 .272.166c.078.07.14.155.182.249a.711.711 0 0 1 .064.293z",
    fill: "#CCC"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.572 9.9a1.042 1.042 0 0 0-.932.048.922.922 0 0 0-.331.32.825.825 0 0 0-.121.427v.05a.705.705 0 0 1 .057-.8c.1-.128.24-.225.402-.278a.913.913 0 0 1 .504-.016.85.85 0 0 1 .423.25h-.002z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M4.152 9.508h-.46v1.752h.46V9.507z",
    fill: "#333"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M14.526 3.07c0 .152-.049.3-.141.427a.827.827 0 0 1-.377.283.912.912 0 0 1-.484.043.866.866 0 0 1-.43-.21.75.75 0 0 1-.23-.393.707.707 0 0 1 .048-.443.787.787 0 0 1 .31-.345.896.896 0 0 1 1.059.096c.157.144.245.339.245.542z",
    fill: "#F7931E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.34 2.587a1.041 1.041 0 0 0-.933.044.923.923 0 0 0-.333.32.825.825 0 0 0-.122.427v.05a.71.71 0 0 1-.06-.54.775.775 0 0 1 .345-.442.901.901 0 0 1 .579-.122.863.863 0 0 1 .522.26l.001.003z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.92 2.194h-.46v1.752h.46V2.194z",
    fill: "#333"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M84.418 5.146c0 .105.034.207.097.294a.57.57 0 0 0 .26.194c.105.04.22.05.333.03a.596.596 0 0 0 .295-.144.515.515 0 0 0 .158-.27.486.486 0 0 0-.033-.306.542.542 0 0 0-.212-.237.616.616 0 0 0-.729.066.506.506 0 0 0-.169.373z",
    fill: "#CCC"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M84.556 4.813a.7.7 0 0 1 .292-.062c.178 0 .348.065.474.18a.589.589 0 0 1 .197.47.479.479 0 0 0 .068-.25.497.497 0 0 0-.1-.312.574.574 0 0 0-.282-.198.628.628 0 0 0-.355-.01.582.582 0 0 0-.294.182z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M84.837 5.751h.317v-1.21h-.317v1.21z",
    fill: "#333"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M84.418 6.31c0 .104.034.206.097.293a.57.57 0 0 0 .26.195c.105.04.22.05.333.03a.596.596 0 0 0 .295-.145.515.515 0 0 0 .158-.27.486.486 0 0 0-.033-.305.542.542 0 0 0-.212-.237.616.616 0 0 0-.729.065.507.507 0 0 0-.169.374z",
    fill: "#F7931E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M84.556 5.977a.7.7 0 0 1 .292-.061c.178 0 .348.064.474.18a.589.589 0 0 1 .197.469.479.479 0 0 0 .068-.25.497.497 0 0 0-.1-.312.574.574 0 0 0-.282-.198.628.628 0 0 0-.355-.01.582.582 0 0 0-.294.182z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M84.837 6.915h.317v-1.21h-.317v1.21z",
    fill: "#333"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M84.418 7.473c0 .105.034.207.097.294a.57.57 0 0 0 .26.194c.105.04.22.05.333.03a.596.596 0 0 0 .295-.144.515.515 0 0 0 .158-.27.486.486 0 0 0-.033-.306.542.542 0 0 0-.212-.237.616.616 0 0 0-.729.066.507.507 0 0 0-.169.373z",
    fill: "#7A7A7A"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M84.556 7.14a.725.725 0 0 1 .642.035c.096.054.175.13.23.22a.574.574 0 0 1 .086.329.498.498 0 0 0-.036-.556.574.574 0 0 0-.28-.194.628.628 0 0 0-.35-.01.583.583 0 0 0-.292.176z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M84.837 8.079h.317v-1.21h-.317v1.21z",
    fill: "#333"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M42.75 1.825h-14.7L30.273.32h11.861c.164 0 .321.06.437.166.116.106.18.25.18.4v.94zM46.716.571h5.396c.112 0 .22.041.3.114.08.073.124.172.124.275v.832H46.29V.96a.36.36 0 0 1 .032-.15.389.389 0 0 1 .093-.125.46.46 0 0 1 .301-.113zM53.164.571h5.396c.112 0 .22.041.3.114.08.073.124.172.124.275v.832h-6.246V.96a.387.387 0 0 1 .125-.275.459.459 0 0 1 .301-.113zM64.181.134h5.862a.207.207 0 0 1 .136.05.164.164 0 0 1 .057.123v1.047H63.99V.307c0-.046.021-.09.057-.122a.201.201 0 0 1 .135-.051z",
    fill: "#CCC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M70.48.94h-6.737v.621h6.738V.94z",
    fill: "#CCC"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M70.715 1.205H63.51v.622h7.204v-.622z",
    fill: "#CCC"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64.181.134h1.323c-.06 0-.106.078-.106.175v.63h-.136v.266h-.13v.622H63.51v-.622h.243V.94H64V.307c0-.045.02-.088.053-.12a.2.2 0 0 1 .13-.053zM70.714 1.205v.622H69.09v-.622h-.127V.94h-.136V.307c0-.096-.047-.175-.104-.175h1.322a.2.2 0 0 1 .135.052.168.168 0 0 1 .056.123V.94h.246v.265h.232z",
    fill: "currentColor",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M71.738.134H77.6a.207.207 0 0 1 .136.05.175.175 0 0 1 .042.056c.01.022.015.044.015.067v1.047h-6.246V.307c0-.046.02-.09.056-.122a.2.2 0 0 1 .135-.051z",
    fill: "#CCC"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M78.037.94H71.3v.621h6.737V.94z",
    fill: "#CCC"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M78.27 1.205h-7.204v.622h7.204v-.622z",
    fill: "#CCC"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M71.737.134h1.323c-.06 0-.106.078-.106.175v.63h-.134v.266h-.13v.622h-1.624v-.622h.235V.94h.247V.307c0-.046.02-.09.056-.122a.2.2 0 0 1 .133-.051zM78.27 1.205v.622h-1.623v-.622h-.128V.94h-.136V.307c0-.096-.047-.175-.104-.175h1.322a.2.2 0 0 1 .136.052.168.168 0 0 1 .056.123V.94h.246v.265h.232z",
    fill: "currentColor",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M19.379 1.268h-.895l.094-1.107a.171.171 0 0 1 .064-.11.202.202 0 0 1 .128-.043h.325a.202.202 0 0 1 .132.041c.037.029.06.069.066.112l.086 1.107z",
    fill: "#F7931E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M19.541 1.104h-1.218v1.088h1.218V1.104z",
    fill: "#CCC"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.768 0h.072c-.055 0-.102.07-.107.161l-.044.943h-.099v1.09h-.267v-1.09h.168l.08-.943a.169.169 0 0 1 .063-.117.2.2 0 0 1 .134-.044zM19.542 1.104v1.09h-.268v-1.09h-.098l-.05-.943c0-.09-.052-.153-.107-.153h.072a.202.202 0 0 1 .135.04.17.17 0 0 1 .068.113l.08.943h.168z",
    fill: "currentColor",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M10.965 17.758H9.522v4.093h1.443v-4.093zM27.71 17.758h-1.442v4.093h1.442v-4.093zM63.73 17.758h-1.442v4.093h1.443v-4.093zM80.477 17.758h-1.443v4.093h1.443v-4.093zM58.85 17.967h-1.512v1.705h1.511v-1.705z",
    fill: "#333"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8 21.648h-4.956v.28H57.8v-.28zM57.8 19.766h-4.956v.281H57.8v-.28z",
    fill: "gray"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M59.494 19.688v2.32a.376.376 0 0 1-.126.275.449.449 0 0 1-.302.114h-1.943a.449.449 0 0 1-.302-.114.376.376 0 0 1-.126-.276v-2.32c0-.103.046-.202.126-.275a.449.449 0 0 1 .302-.114h1.943c.113 0 .222.04.302.114.08.073.125.172.126.276zM36.527 19.9v-.323h-5.149v.322h5.15zM36.53 22.436v-.323h-5.149v.323h5.15z",
    fill: "gray"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M31.616 17.991h-.352v4.712h.352V17.99zM54.346 22.436v-.323h-5.15v.323h5.15z",
    fill: "gray"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M54.109 22.703h.352V17.99h-.352v4.712zM53.058 18.895H32.664c-.367 0-.664.273-.664.608v2.592c0 .336.297.608.664.608h20.394c.367 0 .665-.272.665-.608v-2.591c0-.336-.298-.609-.665-.609z",
    fill: "gray"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.725 19.505v.83a.398.398 0 0 0-.132-.292.475.475 0 0 0-.32-.122h-20.82a.488.488 0 0 0-.32.122.415.415 0 0 0-.097.134.381.381 0 0 0-.034.159v-.83c0-.164.07-.32.197-.435a.704.704 0 0 1 .474-.18h20.386a.704.704 0 0 1 .47.182c.126.115.196.27.196.432z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.724 21.264v.83c0 .164-.07.32-.196.435a.704.704 0 0 1-.475.18H32.666a.704.704 0 0 1-.474-.18.589.589 0 0 1-.197-.434v-.83c0 .053.011.107.034.157.023.05.056.096.098.135a.485.485 0 0 0 .32.12h20.82a.489.489 0 0 0 .323-.119.414.414 0 0 0 .1-.134.383.383 0 0 0 .035-.16z",
    fill: "currentColor",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M10.062 18.62H3.698v.277h6.364v-.276z",
    fill: "#333"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M6.392 20.992H3.84v-3.415h5.627l-1.857 2.86c-.135.18-.317.324-.53.421a1.514 1.514 0 0 1-.687.134z",
    fill: "#333"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9 23.191H.818l2.277-3.713H3.9v3.713z",
    fill: "#333"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M3.385 19.187.791 23.418H.14l2.595-4.231h.651z",
    fill: "gray"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M78.006 18.897h8.296v-.276h-8.296v.276z",
    fill: "#333"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M83.608 20.992h2.553v-3.415H80.53l1.856 2.86c.135.18.319.325.533.422.214.097.451.143.69.133z",
    fill: "#333"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M86.099 23.191h3.081l-2.276-3.713h-.805v3.713z",
    fill: "#333"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m86.612 19.187 2.594 4.231h.653l-2.594-4.231h-.653z",
    fill: "gray"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M76.257 17.695h-9.752v1.31h9.752v-1.31z",
    fill: "#1A1A1A"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M78.575 18.59H64.19c-.727 0-1.317.54-1.317 1.205v1.46c0 .666.59 1.205 1.317 1.205h14.386c.728 0 1.317-.54 1.317-1.205v-1.46c0-.666-.59-1.205-1.317-1.205z",
    fill: "#333"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M63.19 24c1.495 0 2.707-1.109 2.707-2.476 0-1.368-1.212-2.477-2.707-2.477-1.494 0-2.706 1.109-2.706 2.477 0 1.367 1.212 2.476 2.706 2.476z",
    fill: "gray"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M63.19 23.805c1.377 0 2.493-1.021 2.493-2.281 0-1.26-1.116-2.281-2.493-2.281-1.377 0-2.493 1.021-2.493 2.281 0 1.26 1.116 2.281 2.493 2.281z",
    fill: "#4D4D4D"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M64.926 21.524c0 .314-.102.622-.293.883a1.713 1.713 0 0 1-.78.586c-.318.12-.667.152-1.004.09a1.793 1.793 0 0 1-.89-.435 1.554 1.554 0 0 1-.476-.815 1.465 1.465 0 0 1 .1-.92 1.63 1.63 0 0 1 .64-.713 1.878 1.878 0 0 1 1.63-.146c.213.08.404.197.565.345.162.148.29.323.377.516.087.193.132.4.131.609z",
    fill: "#333"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M71.382 24c1.494 0 2.706-1.109 2.706-2.476 0-1.368-1.212-2.477-2.706-2.477-1.495 0-2.706 1.109-2.706 2.477 0 1.367 1.211 2.476 2.706 2.476z",
    fill: "gray"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M71.383 23.805c1.377 0 2.493-1.021 2.493-2.281 0-1.26-1.116-2.281-2.493-2.281-1.377 0-2.493 1.021-2.493 2.281 0 1.26 1.116 2.281 2.493 2.281z",
    fill: "#4D4D4D"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M72.048 22.994c.887-.336 1.308-1.267.941-2.078-.367-.812-1.384-1.197-2.27-.861-.888.336-1.309 1.267-.942 2.078.368.812 1.385 1.197 2.271.86z",
    fill: "#333"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M63.734 21.524a.468.468 0 0 1-.092.276.536.536 0 0 1-.244.183.59.59 0 0 1-.314.029.56.56 0 0 1-.278-.137.486.486 0 0 1-.15-.254.458.458 0 0 1 .032-.288.51.51 0 0 1 .2-.223.58.58 0 0 1 .686.062c.05.046.09.101.118.161a.46.46 0 0 1 .042.19zM68.11 21.026h-1.65v.23h1.65v-.23zM68.11 21.44h-1.65v.23h1.65v-.23zM68.11 20.613h-1.65v.23h1.65v-.23z",
    fill: "#4D4D4D"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "m68.11 20.844-1.65.425v-.23l1.65-.426v.23z",
    fill: "gray"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M68.11 21.85h-1.65v.23h1.65v-.23zM68.11 22.271h-1.65v.23h1.65v-.23z",
    fill: "#4D4D4D"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "m68.11 21.257-1.65.425v-.23l1.65-.426v.23zM68.11 21.67l-1.65.423v-.228l1.65-.425v.23zM68.11 22.08l-1.65.426v-.23l1.65-.425v.23z",
    fill: "gray"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M68.11 20.2h-1.65v.231h1.65v-.23z",
    fill: "#4D4D4D"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "m68.11 20.431-1.65.425v-.23l1.65-.425v.23z",
    fill: "gray"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "m72.015 19.934-3.66-.255h-2.14l-3.657.255a.137.137 0 0 0-.086.04.116.116 0 0 0-.034.08v1.505c0 .033.015.064.04.087.025.023.06.036.095.036h2.18l1.02 1.052c.076.077.168.14.271.182a.868.868 0 0 0 .329.065h1.818a.861.861 0 0 0 .329-.065.798.798 0 0 0 .27-.182l1.022-1.052h2.18c.036 0 .07-.013.096-.036a.118.118 0 0 0 .04-.087v-1.506a.114.114 0 0 0-.035-.08.135.135 0 0 0-.085-.04h.007zm-3.859 2.176c0 .082-.035.16-.098.218a.352.352 0 0 1-.238.09h-1.058a.352.352 0 0 1-.237-.09.295.295 0 0 1-.099-.218v-1.56c0-.082.036-.16.099-.218a.352.352 0 0 1 .237-.09h1.058c.09 0 .175.032.238.09a.294.294 0 0 1 .098.217v1.561z",
    fill: "gray"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M63.627 20.963h-.874c-.097 0-.175.072-.175.16v.8c0 .088.078.16.175.16h.874c.096 0 .174-.072.174-.16v-.8c0-.088-.078-.16-.174-.16zM71.818 20.963h-.874c-.096 0-.175.072-.175.16v.8c0 .088.079.16.175.16h.874c.096 0 .175-.072.175-.16v-.8c0-.088-.079-.16-.175-.16z",
    fill: "#4D4D4D"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M79.574 24c1.495 0 2.706-1.109 2.706-2.476 0-1.368-1.211-2.477-2.706-2.477-1.494 0-2.706 1.109-2.706 2.477 0 1.367 1.212 2.476 2.706 2.476z",
    fill: "gray"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M79.574 23.805c1.377 0 2.493-1.021 2.493-2.281 0-1.26-1.116-2.281-2.493-2.281-1.377 0-2.493 1.021-2.493 2.281 0 1.26 1.116 2.281 2.493 2.281z",
    fill: "#4D4D4D"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M80.239 22.993c.887-.336 1.308-1.267.94-2.078-.367-.812-1.384-1.197-2.27-.861-.887.336-1.309 1.267-.941 2.078.367.811 1.384 1.197 2.27.86z",
    fill: "#333"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M71.926 21.524a.468.468 0 0 1-.092.276.536.536 0 0 1-.243.183.59.59 0 0 1-.315.029.56.56 0 0 1-.278-.137.486.486 0 0 1-.149-.254.458.458 0 0 1 .031-.288.51.51 0 0 1 .2-.223.58.58 0 0 1 .687.062c.05.046.09.101.118.161.027.06.041.126.041.19zM76.304 21.026h-1.65v.23h1.65v-.23zM76.304 21.44h-1.65v.23h1.65v-.23zM76.304 20.613h-1.65v.23h1.65v-.23z",
    fill: "#4D4D4D"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "m76.302 20.844-1.649.425v-.23l1.65-.426v.23z",
    fill: "gray"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M76.304 21.85h-1.65v.23h1.65v-.23zM76.304 22.271h-1.65v.23h1.65v-.23z",
    fill: "#4D4D4D"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "m76.302 21.257-1.649.425v-.23l1.65-.426v.23zM76.302 21.67l-1.649.423v-.228l1.65-.425v.23zM76.302 22.08l-1.649.426v-.23l1.65-.425v.23z",
    fill: "gray"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M76.304 20.2h-1.65v.231h1.65v-.23z",
    fill: "#4D4D4D"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "m76.302 20.431-1.649.425v-.23l1.65-.425v.23z",
    fill: "gray"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "m80.207 19.934-3.659-.255H74.41l-3.659.255a.137.137 0 0 0-.085.04.116.116 0 0 0-.034.08v1.505c0 .033.014.064.04.087a.14.14 0 0 0 .094.036h2.181l1.022 1.052c.075.077.167.14.27.182a.86.86 0 0 0 .329.065h1.818a.868.868 0 0 0 .329-.065.804.804 0 0 0 .27-.182l1.02-1.052h2.181c.036 0 .07-.013.095-.036a.118.118 0 0 0 .04-.087v-1.506a.114.114 0 0 0-.035-.08.135.135 0 0 0-.085-.04h.007zm-3.859 2.176c0 .082-.035.16-.098.218a.352.352 0 0 1-.237.09h-1.059a.352.352 0 0 1-.237-.09.295.295 0 0 1-.098-.218v-1.56c0-.082.035-.16.098-.218a.352.352 0 0 1 .237-.09h1.059c.089 0 .174.032.237.09a.294.294 0 0 1 .098.217v1.561z",
    fill: "gray"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M71.818 20.963h-.874c-.096 0-.175.072-.175.16v.8c0 .088.079.16.175.16h.874c.096 0 .175-.072.175-.16v-.8c0-.088-.079-.16-.175-.16zM80.012 20.963h-.874c-.096 0-.174.072-.174.16v.8c0 .088.078.16.174.16h.874c.097 0 .175-.072.175-.16v-.8c0-.088-.078-.16-.175-.16z",
    fill: "#4D4D4D"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M23.493 17.695H13.74v1.31h9.753v-1.31z",
    fill: "#1A1A1A"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M25.811 18.59H11.425c-.727 0-1.317.54-1.317 1.205v1.46c0 .666.59 1.205 1.317 1.205h14.386c.728 0 1.317-.54 1.317-1.205v-1.46c0-.666-.59-1.205-1.317-1.205z",
    fill: "#333"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M10.425 24c1.494 0 2.706-1.109 2.706-2.476 0-1.368-1.212-2.477-2.706-2.477-1.495 0-2.706 1.109-2.706 2.477C7.719 22.89 8.93 24 10.425 24z",
    fill: "gray"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M10.426 23.805c1.377 0 2.493-1.021 2.493-2.281 0-1.26-1.117-2.281-2.493-2.281-1.377 0-2.493 1.021-2.493 2.281 0 1.26 1.116 2.281 2.493 2.281z",
    fill: "#4D4D4D"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M11.29 22.903c.833-.438 1.12-1.41.642-2.171-.478-.762-1.54-1.025-2.373-.588-.832.438-1.12 1.41-.642 2.172.478.761 1.54 1.024 2.373.587z",
    fill: "#333"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M18.617 24c1.495 0 2.706-1.109 2.706-2.476 0-1.368-1.211-2.477-2.706-2.477-1.494 0-2.706 1.109-2.706 2.477 0 1.367 1.212 2.476 2.706 2.476z",
    fill: "gray"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M18.617 23.805c1.377 0 2.493-1.021 2.493-2.281 0-1.26-1.116-2.281-2.493-2.281-1.377 0-2.493 1.021-2.493 2.281 0 1.26 1.116 2.281 2.493 2.281z",
    fill: "#4D4D4D"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M20.354 21.524c0 .314-.102.622-.293.884a1.715 1.715 0 0 1-.781.586 1.89 1.89 0 0 1-1.006.09 1.793 1.793 0 0 1-.89-.438 1.553 1.553 0 0 1-.474-.816 1.466 1.466 0 0 1 .102-.92 1.63 1.63 0 0 1 .643-.712c.287-.174.624-.266.968-.265.46.001.9.17 1.225.468.325.298.507.702.506 1.123z",
    fill: "#333"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M10.968 21.524a.468.468 0 0 1-.088.278.535.535 0 0 1-.243.186.59.59 0 0 1-.315.03.562.562 0 0 1-.28-.134.486.486 0 0 1-.15-.255.458.458 0 0 1 .03-.288.51.51 0 0 1 .2-.224.58.58 0 0 1 .684.06c.102.091.16.216.162.347zM15.346 21.026h-1.65v.23h1.65v-.23zM15.346 21.44h-1.65v.23h1.65v-.23zM15.346 20.613h-1.65v.23h1.65v-.23z",
    fill: "#4D4D4D"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "m15.346 20.844-1.65.425v-.23l1.65-.426v.23z",
    fill: "gray"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M15.346 21.85h-1.65v.23h1.65v-.23zM15.346 22.271h-1.65v.23h1.65v-.23z",
    fill: "#4D4D4D"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "m15.346 21.257-1.65.425v-.23l1.65-.426v.23zM15.346 21.67l-1.65.423v-.228l1.65-.425v.23zM15.346 22.08l-1.65.426v-.23l1.65-.425v.23z",
    fill: "gray"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M15.346 20.2h-1.65v.231h1.65v-.23z",
    fill: "#4D4D4D"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "m15.346 20.431-1.65.425v-.23l1.65-.425v.23z",
    fill: "gray"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "m19.25 19.934-3.66-.255h-2.14l-3.658.255a.137.137 0 0 0-.085.04.116.116 0 0 0-.034.08v1.505c0 .033.014.064.04.087.024.023.058.036.094.036h2.181l1.02 1.052c.075.077.168.14.27.182a.868.868 0 0 0 .329.065h1.827a.861.861 0 0 0 .329-.065.799.799 0 0 0 .27-.182l1.022-1.052h2.18a.143.143 0 0 0 .095-.036.122.122 0 0 0 .029-.04.112.112 0 0 0 .01-.047v-1.506a.114.114 0 0 0-.035-.08.135.135 0 0 0-.085-.04zm-3.86 2.173c0 .082-.035.16-.098.218a.352.352 0 0 1-.237.09H13.99a.352.352 0 0 1-.237-.09.294.294 0 0 1-.098-.218V20.55c0-.081.035-.16.098-.217a.352.352 0 0 1 .237-.09h1.059c.089 0 .174.032.237.09a.294.294 0 0 1 .098.217l.005 1.558z",
    fill: "gray"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M10.861 20.963h-.874c-.096 0-.175.072-.175.16v.8c0 .088.079.16.175.16h.874c.096 0 .175-.072.175-.16v-.8c0-.088-.079-.16-.175-.16zM19.053 20.963h-.874c-.096 0-.174.072-.174.16v.8c0 .088.078.16.174.16h.874c.097 0 .175-.072.175-.16v-.8c0-.088-.078-.16-.175-.16z",
    fill: "#4D4D4D"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M26.81 24c1.494 0 2.706-1.109 2.706-2.476 0-1.368-1.212-2.477-2.706-2.477-1.495 0-2.706 1.109-2.706 2.477 0 1.367 1.211 2.476 2.706 2.476z",
    fill: "gray"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M26.81 23.805c1.376 0 2.492-1.021 2.492-2.281 0-1.26-1.116-2.281-2.493-2.281-1.376 0-2.493 1.021-2.493 2.281 0 1.26 1.117 2.281 2.493 2.281z",
    fill: "#4D4D4D"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M27.47 22.995c.888-.334 1.312-1.264.947-2.076-.365-.812-1.38-1.2-2.269-.866-.887.334-1.311 1.263-.946 2.076.365.812 1.38 1.2 2.268.866z",
    fill: "#333"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M19.161 21.524a.467.467 0 0 1-.088.278.534.534 0 0 1-.244.186.59.59 0 0 1-.315.03.561.561 0 0 1-.28-.136.486.486 0 0 1-.15-.255.459.459 0 0 1 .032-.289.51.51 0 0 1 .203-.223.58.58 0 0 1 .683.063c.1.092.158.216.16.346zM23.538 21.026h-1.651v.23h1.65v-.23zM23.538 21.44h-1.651v.23h1.65v-.23zM23.538 20.613h-1.651v.23h1.65v-.23z",
    fill: "#4D4D4D"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "m23.538 20.844-1.65.425v-.23l1.65-.426v.23z",
    fill: "gray"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M23.538 21.85h-1.651v.23h1.65v-.23zM23.538 22.271h-1.651v.23h1.65v-.23z",
    fill: "#4D4D4D"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "m23.538 21.257-1.65.425v-.23l1.65-.426v.23zM23.538 21.67l-1.65.423v-.228l1.65-.425v.23zM23.538 22.08l-1.65.426v-.23l1.65-.425v.23z",
    fill: "gray"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M23.538 20.2h-1.651v.231h1.65v-.23z",
    fill: "#4D4D4D"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "m23.538 20.431-1.65.425v-.23l1.65-.425v.23z",
    fill: "gray"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "m27.441 19.934-3.659-.255h-2.14l-3.66.255a.137.137 0 0 0-.085.04.116.116 0 0 0-.034.08v1.505c0 .033.014.064.04.087.025.023.059.036.095.036h2.18l1.022 1.052c.075.077.167.14.27.182a.861.861 0 0 0 .33.065h1.818a.863.863 0 0 0 .327-.065.799.799 0 0 0 .27-.182l1.022-1.052h2.18c.036 0 .07-.013.096-.036a.118.118 0 0 0 .039-.087v-1.506a.114.114 0 0 0-.034-.08.135.135 0 0 0-.085-.04h.008zm-3.858 2.176c0 .082-.036.16-.099.218a.352.352 0 0 1-.237.09h-1.059a.352.352 0 0 1-.237-.09.295.295 0 0 1-.098-.218v-1.56c0-.082.035-.16.098-.218a.352.352 0 0 1 .237-.09h1.059c.089 0 .174.032.237.09a.294.294 0 0 1 .098.217v1.561z",
    fill: "gray"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M19.053 20.963h-.874c-.096 0-.174.072-.174.16v.8c0 .088.078.16.174.16h.874c.097 0 .175-.072.175-.16v-.8c0-.088-.078-.16-.175-.16zM27.246 20.963h-.874c-.097 0-.175.072-.175.16v.8c0 .088.078.16.175.16h.874c.096 0 .174-.072.174-.16v-.8c0-.088-.078-.16-.174-.16z",
    fill: "#4D4D4D"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M84.921 2.06v14.674H4.026V9.646c0-.232.05-.462.148-.676.097-.214.24-.41.419-.573a1.95 1.95 0 0 1 .627-.382c.234-.088.485-.134.74-.133h6.725c.26 0 .51-.095.694-.263a.861.861 0 0 0 .287-.635V2.06c0-.158.069-.31.191-.422a.683.683 0 0 1 .46-.174h69.96a.684.684 0 0 1 .455.177c.12.111.189.262.189.419z",
    fill: "#7A7A7A"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M84.92 2.06v1.27H13.667V2.06c0-.078.017-.155.05-.228a.594.594 0 0 1 .141-.193c.06-.056.133-.1.212-.13a.704.704 0 0 1 .25-.044h69.95c.172 0 .338.063.46.174a.573.573 0 0 1 .192.422z",
    fill: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M84.92 2.059v.413c0-.158-.069-.31-.191-.421a.685.685 0 0 0-.46-.175h-69.95a.684.684 0 0 0-.461.175.573.573 0 0 0-.192.42V2.06c0-.078.017-.156.05-.228a.595.595 0 0 1 .142-.193.658.658 0 0 1 .211-.128.704.704 0 0 1 .25-.045h69.95c.085 0 .17.015.248.045.08.03.151.073.212.128.06.055.109.121.142.193.032.072.05.15.05.228z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M84.921 13.99H4.033v2.744h80.888v-2.743z",
    fill: "#7A7A7A"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M55.293 18.945H30.432l-1.933-1.532h28.727l-1.933 1.532z",
    fill: "#333"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M86.387 16.531H3.61v1.623h82.777v-1.623z",
    fill: "#666"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "m3.61 17.3-.84-.618v-.15h.84v.768zM86.387 17.3l.842-.618v-.15h-.842v.768z",
    fill: "#4D4D4D"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M16.502 4.796V7.58a.23.23 0 0 1-.078.175.292.292 0 0 1-.19.073h-1.566a.29.29 0 0 1-.136-.034.258.258 0 0 1-.099-.093.224.224 0 0 1-.034-.12V4.796c0-.065.029-.128.079-.174a.282.282 0 0 1 .19-.072h1.565c.071 0 .14.026.19.072.05.046.079.109.079.174z",
    fill: "#1C5185"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M15.905 4.55 14.428 7.7a.225.225 0 0 1-.034-.12V4.797c0-.065.029-.128.08-.174a.281.281 0 0 1 .189-.072h1.242z",
    fill: "#fff"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M16.231 4.632a.19.19 0 0 1 .128.048.16.16 0 0 1 .053.116v2.785a.16.16 0 0 1-.053.116.19.19 0 0 1-.128.048h-1.563a.188.188 0 0 1-.127-.048.157.157 0 0 1-.053-.116V4.796c0-.043.019-.085.053-.116a.188.188 0 0 1 .127-.048h1.563zm0-.164h-1.563a.377.377 0 0 0-.254.096.315.315 0 0 0-.105.232v2.785c0 .087.037.17.105.232a.377.377 0 0 0 .254.097h1.563a.388.388 0 0 0 .255-.096.328.328 0 0 0 .078-.107.304.304 0 0 0 .028-.126V4.796a.304.304 0 0 0-.028-.126.328.328 0 0 0-.078-.107.388.388 0 0 0-.255-.096z",
    fill: "#4D4D4D"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M24.478 4.796V7.58a.229.229 0 0 1-.02.095.247.247 0 0 1-.059.08.291.291 0 0 1-.192.073H22.65a.284.284 0 0 1-.191-.072.237.237 0 0 1-.08-.175V4.796c.001-.065.03-.128.08-.174a.284.284 0 0 1 .191-.072h1.564c.07.001.137.028.187.074.05.046.077.107.078.172z",
    fill: "#1C5185"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M24.478 4.796v.307L23.203 7.83h-.554a.284.284 0 0 1-.191-.073.237.237 0 0 1-.08-.174V7.46l1.361-2.917h.474a.291.291 0 0 1 .19.076.247.247 0 0 1 .056.081.23.23 0 0 1 .019.095z",
    fill: "#fff"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M24.207 4.632c.047 0 .093.017.127.048.033.031.052.073.052.116v2.785a.157.157 0 0 1-.052.116.188.188 0 0 1-.127.048h-1.559a.188.188 0 0 1-.127-.048.157.157 0 0 1-.052-.116V4.796c0-.043.018-.085.052-.116a.188.188 0 0 1 .127-.048h1.559zm0-.164h-1.559a.377.377 0 0 0-.254.096.315.315 0 0 0-.105.232v2.785c0 .087.038.17.105.232a.377.377 0 0 0 .254.097h1.564a.377.377 0 0 0 .254-.096.315.315 0 0 0 .105-.233V4.796a.315.315 0 0 0-.105-.232.377.377 0 0 0-.254-.096h-.005z",
    fill: "#4D4D4D"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M21.99 4.796V7.58a.237.237 0 0 1-.08.174.283.283 0 0 1-.19.073h-4.564a.283.283 0 0 1-.191-.072.237.237 0 0 1-.08-.175V4.796c.001-.065.03-.128.08-.174a.284.284 0 0 1 .19-.072h4.566c.071 0 .14.026.19.072.05.046.078.109.078.174z",
    fill: "#1C5185"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "m18.079 4.55-1.193 2.553V4.801c0-.066.029-.128.08-.174a.284.284 0 0 1 .19-.072l.923-.005zM21.37 4.55 19.84 7.828h-2.201l1.53-3.278h2.203zM21.99 5.88v1.7a.237.237 0 0 1-.08.175.283.283 0 0 1-.189.073h-.64l.908-1.948z",
    fill: "#fff"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M21.722 4.632c.047 0 .093.017.127.048.033.031.052.073.052.116v2.785a.157.157 0 0 1-.052.116.188.188 0 0 1-.127.048h-4.565a.194.194 0 0 1-.128-.047.165.165 0 0 1-.04-.054.153.153 0 0 1-.014-.063V4.796c0-.021.005-.043.014-.063a.165.165 0 0 1 .04-.053.194.194 0 0 1 .128-.048h4.565zm0-.164h-4.565a.388.388 0 0 0-.255.095.328.328 0 0 0-.079.107.304.304 0 0 0-.027.126v2.785c0 .043.01.086.027.126.018.04.045.077.079.107a.388.388 0 0 0 .255.096h4.565a.377.377 0 0 0 .253-.096.315.315 0 0 0 .106-.233V4.796a.315.315 0 0 0-.105-.232.377.377 0 0 0-.254-.096z",
    fill: "#4D4D4D"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M62.938 17.713H26.014l-2.141-2.121h41.206l-2.141 2.121z",
    fill: "#7A7A7A"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M44.515 6.602h-8.053V4.535h8.053v2.067zm-7.897-.154h7.734V4.684h-7.734v1.764z",
    fill: "#333"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M40.556 4.581h-.146v1.927h.146V4.58zM52.41 6.602h-8.054V4.535h8.053v2.067zm-7.896-.154h7.734V4.684h-7.734v1.764z",
    fill: "#333"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M48.454 4.581h-.146v1.927h.146V4.58zM60.306 6.602h-8.053V4.535h8.053v2.067zm-7.897-.154h7.734V4.684H52.41v1.764z",
    fill: "#333"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M56.351 4.581h-.146v1.927h.146V4.58zM44.515 16.888h-8.053V7.974h8.053v8.914zm-7.897-.154h7.734V8.121h-7.734v8.613z",
    fill: "#333"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M40.556 8.019h-.146v8.784h.146V8.019zM52.41 16.888h-8.054V7.974h8.053v8.914zm-7.896-.154h7.734V8.121h-7.734v8.613z",
    fill: "#333"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M48.454 8.019h-.146v8.784h.146V8.019zM60.306 16.888h-8.053V7.974h8.053v8.914zm-7.897-.154h7.734V8.121H52.41v8.613z",
    fill: "#333"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M56.351 8.019h-.146v8.784h.146V8.019z",
    fill: "#333"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M22.78 18.747h-8.323c-.224 0-.406.166-.406.371v.63c0 .205.182.371.406.371h8.323c.224 0 .406-.166.406-.372v-.629c0-.205-.182-.371-.406-.371zM75.543 18.747h-8.32c-.225 0-.408.167-.408.373v.626c0 .206.183.373.408.373h8.32c.225 0 .407-.167.407-.373v-.626c0-.206-.182-.373-.407-.373z",
    fill: "#4D4D4D"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.938 7.994h-9.731V4.463h9.73v3.53zm-9.515-.197h9.305V4.664h-9.305v3.133z",
    fill: "currentColor",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.782 4.632h-.146V7.83h.146V4.632zM26.199 4.632h-.146V7.83h.146V4.632zM26.615 4.632h-.146V7.83h.146V4.632zM27.029 4.632h-.146V7.83h.146V4.632zM27.445 4.632h-.146V7.83h.146V4.632zM27.86 4.632h-.145V7.83h.146V4.632zM28.276 4.632h-.146V7.83h.146V4.632zM28.69 4.632h-.145V7.83h.146V4.632zM29.107 4.632h-.146V7.83h.146V4.632zM29.523 4.632h-.146V7.83h.146V4.632zM29.938 4.632h-.146V7.83h.146V4.632zM30.354 4.632h-.146V7.83h.146V4.632zM30.77 4.632h-.146V7.83h.146V4.632zM31.184 4.632h-.146V7.83h.146V4.632zM31.6 4.632h-.146V7.83h.146V4.632zM32.016 4.632h-.146V7.83h.146V4.632zM32.432 4.632h-.146V7.83h.146V4.632zM32.847 4.632h-.146V7.83h.146V4.632zM33.263 4.632h-.146V7.83h.146V4.632zM33.68 4.632h-.147V7.83h.146V4.632zM34.093 4.632h-.146V7.83h.146V4.632zM34.51 4.632h-.147V7.83h.146V4.632z",
    fill: "currentColor",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.844 15.66H60.872V4.417h11.972V15.66zm-11.708-.194H72.58V4.606H61.135v10.86z",
    fill: "currentColor",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.579 4.58h-.18v10.923h.18V4.58zM62.089 4.58h-.18v10.923h.18V4.58zM62.6 4.58h-.18v10.923h.18V4.58zM63.111 4.58h-.18v10.923h.18V4.58zM63.624 4.58h-.18v10.923h.18V4.58zM64.135 4.58h-.18v10.923h.18V4.58zM64.647 4.58h-.18v10.923h.18V4.58zM65.157 4.58h-.18v10.923h.18V4.58zM65.668 4.58h-.18v10.923h.18V4.58zM66.18 4.58h-.179v10.923h.18V4.58zM66.691 4.58h-.18v10.923h.18V4.58zM67.204 4.58h-.18v10.923h.18V4.58zM67.714 4.58h-.18v10.923h.18V4.58zM68.225 4.58h-.18v10.923h.18V4.58zM68.737 4.58h-.18v10.923h.18V4.58zM69.249 4.58h-.18v10.923h.18V4.58zM69.76 4.58h-.179v10.923h.18V4.58zM70.272 4.58h-.18v10.923h.18V4.58zM70.782 4.58h-.18v10.923h.18V4.58zM71.294 4.58h-.18v10.923h.18V4.58zM71.805 4.58h-.179v10.923h.18V4.58zM72.317 4.58h-.18v10.923h.18V4.58z",
    fill: "currentColor",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.31 7.994h-9.73V4.463h9.73v3.53zm-9.514-.197h9.3V4.664h-9.3v3.133z",
    fill: "currentColor",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.155 4.632h-.146V7.83h.146V4.632zM74.57 4.632h-.145V7.83h.146V4.632zM74.988 4.632h-.146V7.83h.146V4.632zM75.402 4.632h-.146V7.83h.146V4.632zM75.818 4.632h-.146V7.83h.146V4.632zM76.234 4.632h-.146V7.83h.146V4.632zM76.649 4.632h-.146V7.83h.146V4.632zM77.064 4.632h-.146V7.83h.146V4.632zM77.48 4.632h-.146V7.83h.146V4.632zM77.897 4.632h-.146V7.83h.146V4.632zM78.311 4.632h-.146V7.83h.146V4.632zM78.727 4.632h-.146V7.83h.146V4.632zM79.143 4.632h-.146V7.83h.146V4.632zM79.557 4.632h-.146V7.83h.146V4.632zM79.973 4.632h-.146V7.83h.146V4.632zM80.39 4.632h-.147V7.83h.146V4.632zM80.806 4.632h-.146V7.83h.146V4.632zM81.22 4.632h-.146V7.83h.146V4.632zM81.636 4.632h-.146V7.83h.146V4.632zM82.052 4.632h-.146V7.83h.146V4.632zM82.466 4.632h-.146V7.83h.146V4.632zM82.882 4.632h-.146V7.83h.146V4.632z",
    fill: "currentColor",
    style: {
      mixBlendMode: "overlay"
    }
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M31.264 12.485h-3.092v-3.33h3.092v3.33zm-2.985-.099h2.878V9.253h-2.878v3.133zM31.264 16.15h-3.092v-3.33h3.092v3.33zm-2.985-.099h2.878v-3.133h-2.878v3.133z",
    fill: "#333"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M31.221 10.444h-.377v.634h.377v-.634zM31.221 14.226h-.377v.634h.377v-.634zM34.739 12.485h-3.092v-3.33h3.092v3.33zm-2.985-.099h2.877V9.253h-2.877v3.133zM34.739 16.15h-3.092v-3.33h3.092v3.33zm-2.985-.099h2.877v-3.133h-2.877v3.133z",
    fill: "#333"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M34.696 10.444h-.378v.634h.378v-.634zM34.696 14.226h-.378v.634h.378v-.634zM76.518 12h-3.092V8.67h3.092V12zm-2.985-.098h2.877V8.768h-2.877v3.134zM76.518 15.66h-3.092v-3.325h3.092v3.324zm-2.985-.1h2.877v-3.125h-2.877v3.126z",
    fill: "#333"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M76.476 9.96H76.1v.634h.377V9.96zM76.476 13.74H76.1v.634h.377v-.634zM79.991 12H76.9V8.67h3.092V12zm-2.986-.098h2.877V8.768h-2.877v3.134zM79.991 15.66H76.9v-3.325h3.092v3.324zm-2.986-.093h2.877v-3.132h-2.877v3.132z",
    fill: "#333"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M79.95 9.96h-.377v.634h.378V9.96zM79.95 13.74h-.377v.634h.378v-.634zM83.466 12h-3.092V8.67h3.092V12zm-2.985-.098h2.878V8.768H80.48v3.134zM83.466 15.66h-3.092v-3.325h3.092v3.324zm-2.985-.1h2.878v-3.125H80.48v3.126z",
    fill: "#333"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M83.424 9.96h-.377v.634h.377V9.96zM83.424 13.74h-.377v.634h.377v-.634zM11.309 15.793H5.2V12.4h6.109v3.393zm-6.04-.063h5.97v-3.267H5.275l-.005 3.267z",
    fill: "#333"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M11.273 12.681h-.583v.407h.583v-.407zM11.273 15.105h-.583v.407h.583v-.407zM18.147 15.793h-6.103V12.4h6.103v3.393zm-6.04-.063h5.967v-3.267h-5.961l-.005 3.267z",
    fill: "#333"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M18.11 12.681h-.582v.407h.582v-.407zM18.11 15.105h-.582v.407h.582v-.407zM24.986 15.793h-6.103V12.4h6.103v3.393zm-6.04-.063h5.966v-3.267h-5.954l-.011 3.267z",
    fill: "#333"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M24.95 12.681h-.583v.407h.582v-.407zM24.95 15.105h-.583v.407h.582v-.407zM11.309 12.027H5.2V8.634h6.109v3.393zm-6.04-.063h5.97V8.697H5.275l-.005 3.267z",
    fill: "#333"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M11.273 8.915h-.583v.407h.583v-.407zM11.273 11.34h-.583v.406h.583v-.407zM18.147 12.027h-6.103V8.634h6.103v3.393zm-6.04-.063h5.967V8.697h-5.961l-.005 3.267z",
    fill: "#333"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M18.11 8.915h-.582v.407h.582v-.407zM18.11 11.34h-.582v.406h.582v-.407zM24.986 12.027h-6.103V8.634h6.103v3.393zm-6.04-.063h5.966V8.697h-5.954l-.011 3.267z",
    fill: "#333"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M24.95 8.915h-.583v.407h.582v-.407zM24.95 11.34h-.583v.406h.582v-.407z",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M59.494 19.688v.525h-2.799v-.525c0-.104.046-.203.126-.276a.449.449 0 0 1 .302-.114h1.943c.113 0 .222.04.302.114.08.073.125.172.126.276z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.494 21.482v.526a.376.376 0 0 1-.126.275.449.449 0 0 1-.302.114h-1.943a.449.449 0 0 1-.302-.114.376.376 0 0 1-.126-.276v-.525h2.799z",
    fill: "currentColor",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.034 1.867h-1.832v.277h1.832v-.277zM40.113 1.867h-1.832v.277h1.832v-.277zM42.19 1.867h-1.832v.277h1.832v-.277zM38.034 2.26h-1.832v.277h1.832V2.26zM40.113 2.26h-1.832v.277h1.832V2.26zM42.19 2.26h-1.832v.277h1.832V2.26zM38.034 2.652h-1.832v.276h1.832v-.276zM40.113 2.652h-1.832v.276h1.832v-.276zM42.19 2.652h-1.832v.276h1.832v-.276z",
    fill: "currentColor",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.065 1.867h-1.832v.277h1.832v-.277zM50.143 1.867H48.31v.277h1.833v-.277zM52.22 1.867H50.39v.277h1.832v-.277zM48.065 2.26h-1.832v.277h1.832V2.26zM50.143 2.26H48.31v.277h1.833V2.26zM52.22 2.26H50.39v.277h1.832V2.26zM48.065 2.652h-1.832v.276h1.832v-.276zM50.143 2.652H48.31v.276h1.833v-.276zM52.22 2.652H50.39v.276h1.832v-.276z",
    fill: "currentColor",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.097 1.867h-1.832v.277h1.832v-.277zM60.173 1.867H58.34v.277h1.832v-.277zM62.252 1.867H60.42v.277h1.832v-.277zM58.097 2.26h-1.832v.277h1.832V2.26zM60.173 2.26H58.34v.277h1.832V2.26zM62.252 2.26H60.42v.277h1.832V2.26zM58.097 2.652h-1.832v.276h1.832v-.276zM60.173 2.652H58.34v.276h1.832v-.276zM62.252 2.652H60.42v.276h1.832v-.276z",
    fill: "currentColor",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.126 1.867h-1.832v.277h1.832v-.277zM70.205 1.867h-1.832v.277h1.832v-.277zM72.283 1.867h-1.832v.277h1.832v-.277zM68.126 2.26h-1.832v.277h1.832V2.26zM70.205 2.26h-1.832v.277h1.832V2.26zM72.283 2.26h-1.832v.277h1.832V2.26zM68.126 2.652h-1.832v.276h1.832v-.276zM70.205 2.652h-1.832v.276h1.832v-.276zM72.283 2.652h-1.832v.276h1.832v-.276z",
    fill: "currentColor",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.184 19.433v.307a.357.357 0 0 1-.119.263.426.426 0 0 1-.287.109h-8.321a.426.426 0 0 1-.287-.11.357.357 0 0 1-.12-.262v-.307h9.134zM75.949 19.433v.307c0 .049-.01.097-.031.142a.371.371 0 0 1-.088.12.438.438 0 0 1-.287.109H67.22a.426.426 0 0 1-.287-.108.357.357 0 0 1-.119-.263v-.307h9.134z",
    fill: "currentColor",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.2
  }), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M62.635 18.406h-4.392v.58h4.392v-.58z",
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocomotive);
export default __webpack_public_path__ + "static/media/locomotive.bc3338841aaf4ea3d4a52f3da797f4ab.svg";
export { ForwardRef as ReactComponent };